import { isAIFCAction } from '@atlassian/conversation-assistant-action-helpers/utils';
import {
	isStoreAssistant,
	type StoreChatItem,
} from '@atlassian/conversation-assistant-store/controllers/chat/types';

type MessageFilter = (message: StoreChatItem) => boolean;

type AssistantMessageMetadata = {
	key?: string;
	is_action_execution?: boolean;
};

type AssistantMessageContent = {
	message?: {
		message?: {
			message_metadata?: AssistantMessageMetadata;
		};
	};
};

// Filter that removes "Action executed" messages from being displayed to users (by leveraging message metadata, not content)
const aifcActionExecutionMessageFilter: MessageFilter = (msg: StoreChatItem) => {
	const assistantMessageMetadata = (
		'content' in msg ? (msg.content as AssistantMessageContent) : undefined
	)?.message?.message?.message_metadata;
	const actionKey = assistantMessageMetadata?.key;

	const shouldFilterOut =
		isStoreAssistant(msg) &&
		assistantMessageMetadata?.is_action_execution === true &&
		actionKey &&
		isAIFCAction({ key: actionKey });

	return !shouldFilterOut;
};

// FOR DEVELOPERS: Add message filter functions to this array. Functions should return true to keep the message, false to filter it out.
const MESSAGE_FILTERS: MessageFilter[] = [aifcActionExecutionMessageFilter];

// Filter the messages based on the message filters. Returns a new array with the filtered messages.
export const filterChatMessages = (messages: StoreChatItem[]): StoreChatItem[] => {
	return messages.filter((message) => {
		return MESSAGE_FILTERS.every((filter) => {
			const result = filter(message);
			// Only filter out if explicitly false; undefined/missing return defaults to keeping the message
			return result !== false;
		});
	});
};
